import script from "./navFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./navFooter.vue?vue&type=script&setup=true&lang=js"

import "./navFooter.vue?vue&type=style&index=0&id=71da459a&lang=less&scoped=true"

import exportComponent from "../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71da459a"]])

export default __exports__